import { render, staticRenderFns } from "./OmtkOrderItemActFilesDialog.vue?vue&type=template&id=66474606"
import script from "./OmtkOrderItemActFilesDialog.vue?vue&type=script&lang=js"
export * from "./OmtkOrderItemActFilesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports